import React from "react";
import {
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  
  marginTop: 7,
  [`& .MuiStepConnector-line`]: {
    borderColor: "#A1AEBE",
    borderWidth: 2.5,
    borderStyle: "dotted",  
  },

  [`&.Mui-active`]: {
    [`& .MuiStepConnector-line`]: {
      borderColor: "#0055A8",
    },
  },

  [`&.Mui-completed`]: {
    [`& .MuiStepConnector-line`]: {
      borderColor: "#0055A8",
    },
  },
}));


const CustomStepIcon = styled("div")<{
  active?: boolean;
  completed?: boolean;
}>(({ theme, active, completed }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 40,
  height: 40,
  borderRadius: "50%",
  backgroundColor: completed
    ? "#0055A8"
    : active
    ? "#0055A8"
    : "#DDDDDD",  
  color: active || completed ? "#FFFFFF" : "#FFFFFF",
  fontWeight: active || completed ? "bold" : "normal",
  fontSize: "14px",
}));



const StepperComp = ({ activeStep , stepsList }: { activeStep: number , stepsList: string[] }) => {
  return (
    <Stepper
      alternativeLabel
      activeStep={activeStep}
      connector={<CustomConnector />}
    >
      {stepsList.map((label, index) => (
        <Step key={label}>
          <StepLabel
            StepIconComponent={(props) => (
              <CustomStepIcon
                active={props.active}
                completed={props.completed}
              >
                {String(index + 1).padStart(2, "0")}
              </CustomStepIcon>
            )}
          >
            <Typography
             variant="body1"
            >
              {label}
            </Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default StepperComp;
